var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Assign-tiktok"},[_c('el-empty',{attrs:{"image":_vm.pic,"description":_vm.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }